import base from "./base";
import wordpress from "./wordpress";
import profile from "./profile";
import checkout from "./checkout";
import store from "./store";
import forms from "./forms";
import catalog from "./catalog";

const routes = [
  {
    path: "/",
    name: "Home",
    props: route => ({
      additionalParam: route.query.additional_param
    }),
    component: () => import("@/views/catalog/Category.vue"),
    meta: {
      slug: "homepage-la-spesa-online"
    }
  },

  ...base,
  ...wordpress,
  ...profile,
  ...checkout,
  ...store,
  ...forms,
  ...catalog
];

export default routes;
